import { render, staticRenderFns } from "./BankAccount.vue?vue&type=template&id=31561c0b&scoped=true"
import script from "./BankAccount.vue?vue&type=script&lang=js"
export * from "./BankAccount.vue?vue&type=script&lang=js"
import style0 from "./BankAccount.vue?vue&type=style&index=0&id=31561c0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31561c0b",
  null
  
)

export default component.exports